module.exports = __webpack_public_path__ + "img/26-jeep-wrangler.5d4a3a00.jpg";